module.exports = __webpack_public_path__ + "img/stop.fd1b59c6.svg";